import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const update = () => {
      const cart = JSON.parse(localStorage.getItem('cart') || '[]');
      setCartCount(cart.reduce((s: number, i: { quantity: number }) => s + i.quantity, 0));
    };
    update();
    window.addEventListener('cartUpdated', update);
    return () => window.removeEventListener('cartUpdated', update);
  }, []);

  const transparent = isHome && !isScrolled;

  const navLinks = [
    { to: '/kategoriler', label: 'Ürünler' },
    { to: '/ozel-tasarim', label: 'Özel Tasarım' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? 'bg-transparent'
          : 'bg-white border-b border-gray-100'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <div className="w-9 h-9 flex items-center justify-center">
              <img
                src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b0491aed407a41b3522bccd609c14102.png"
                alt="Hediyatik"
                className="w-full h-full object-contain"
              />
            </div>
            <span className={`text-xl font-black font-['Playfair_Display'] transition-colors ${transparent ? 'text-white' : 'text-gray-900'}`}>
              Hediyatik
            </span>
          </Link>

          {/* Desktop nav links */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(l => (
              <Link
                key={l.to}
                to={l.to}
                className={`text-sm font-semibold transition-colors whitespace-nowrap ${
                  location.pathname === l.to
                    ? 'text-orange-500'
                    : transparent
                    ? 'text-white/90 hover:text-white'
                    : 'text-gray-700 hover:text-gray-900'
                }`}
              >
                {l.label}
              </Link>
            ))}
          </div>

          {/* Right side */}
          <div className="flex items-center gap-1">
            {/* Cart — visible on all sizes */}
            <button
              onClick={() => navigate('/sepet')}
              className={`relative w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
                transparent ? 'text-white hover:bg-white/10' : 'text-gray-700 hover:bg-gray-100'
              }`}
              aria-label="Sepet"
            >
              <i className="ri-shopping-cart-line text-xl"></i>
              {cartCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-orange-500 text-white text-[10px] font-bold min-w-[18px] min-h-[18px] flex items-center justify-center rounded-full px-1">
                  {cartCount}
                </span>
              )}
            </button>

            {/* CTA button — desktop only */}
            <button
              onClick={() => navigate('/ozel-tasarim')}
              className="hidden md:flex items-center gap-1.5 px-4 py-2 bg-orange-500 hover:bg-orange-600 text-white text-xs font-bold rounded-lg transition-all whitespace-nowrap ml-2 cursor-pointer"
            >
              <i className="ri-edit-line"></i>
              Özel Tasarım
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
